export const PASS_SALE = "passSale";
export const REALIZE_VOUCHER = "realizeVoucher";